<template>
  <div class='ordersettle'>
    <div class="main">
      <!--外送+自提-->
      <div class="tabBar" v-if="is_take_out == 1 && (is_self_take_new == 1 && is_eat_in == 0)">
        <div :class="['fl', 'take', {'active': isShow}]" @click="switchStatus('take-away')"><p>外卖配送</p></div>
        <div :class="['fl', 'self', {'active': !isShow}]" @click="switchStatus('take-self')">
          <p>打包自提</p>
          <!--<span class="self-take-icon"></span>-->
        </div>
        <span class="triangle"></span>
      </div>
      <!--外送+堂食-->
      <div class="tabBar" v-if="is_take_out == 1 && (is_self_take_new == 0 && is_eat_in == 1)">
        <div :class="['fl', 'take', {'active': isShow}]" @click="switchStatus('take-away')"><p>外卖配送</p></div>
        <div :class="['fl', 'self', {'active': !isShow}]" @click="switchStatus('take-eat')"><p>堂食</p>
          <!--<span class="eat-in-icon"></span>-->
        </div>
        <span class="triangle"></span>
      </div>
      <!--自提+堂食-->
      <div class="tabBar" v-if="(is_self_take_new == 1 && is_eat_in == 1) && is_take_out == 0">
        <div :class="['fl', 'take', {'active': showSelf}]" @click="switchStatus('take-self')"><p>打包自提</p></div>
        <div :class="['fl', 'self', {'active': showEat}]" @click="switchStatus('take-eat')"><p>堂食</p>
          <!--<span class="eat-in-icon"></span>-->
        </div>
        <span class="triangle"></span>
      </div>
      <!--外送+自提+堂食-->
      <div class="tabBar" v-if="is_take_out == 1 && (is_self_take_new == 1 && is_eat_in == 1)">
        <div :class="['fl', 'take', 'newTab', {'active': showTake}]" @click="switchStatus('take-away')"><p>外卖配送</p>
        </div>
        <div :class="['fl', 'self', 'newTab', {'active': showSelf}]" @click="switchStatus('take-self')"><p>打包自提</p>
          <!--<span class="self-take-icon new-take-icon"></span>-->
        </div>
        <div :class="['fl', 'self', 'newTab', {'active': showEat}]" @click="switchStatus('take-eat')"><p>堂食</p>
          <!--<span class="eat-in-icon"></span>-->
        </div>
      </div>
      <!--外送地址-->
      <div v-if="is_take_out == 1 && showTake">
        <div class="address" style="padding: 0.3rem 0.2rem 0 .2rem !important;">
          <!--外送-->
          <div class="oneTab" v-if="is_take_out == 1 && (is_eat_in == 0 && is_self_take_new == 0)">
            <span style="font-size: .32rem;color: #333;font-weight: 600;">外卖配送</span>
          </div>
          <div class="address-bottom">
            <div @click="jumpToaddress" class="arrow-right" v-if="JSON.stringify(defaultAddress) === '{}'">
              新增收货地址
            </div>
            <div @click="jumpToaddress" class="arrow-right" v-else>
              <div class="big">{{ defaultAddress.addressee }} {{ defaultAddress.mp }}</div>
              <div v-if="!defaultAddress.isLimitFloor" class="small">
                <span v-if="defaultAddress.poi_address && defaultAddress.detail">{{ defaultAddress.poi_address }} {{ defaultAddress.detail }}</span>
                <span
                  v-else-if="defaultAddress.build_name">【{{ defaultAddress.build_name }}-{{
                    defaultAddress.floor_name
                  }}-{{ defaultAddress.room_name }}】</span>
                <span v-else>{{ defaultAddress.poi_address }}</span>
              </div>
              <div v-else>
               <span
                 v-if="defaultAddress.build_name">【{{ defaultAddress.build_name }}-{{
                    defaultAddress.floor_name
                  }}-{{ defaultAddress.room_name }}】</span>
                <span v-else>{{ defaultAddress.poi_address }} {{ defaultAddress.detail }}</span>
              </div>
            </div>
          </div>
        </div>
        <div :class="orderPreviewInfo.isCanChooseDeliveryWay ? 'sendTime': 'sendTime pb20 mb20'" id="inputPanel">
          <div class="select arrive-time arrow-right" @click="toggleProp">
            <span>送达时间</span>
            <div class="input-text" style="font-weight: 600">
              {{ selectDateName }} {{ selectTimeName }}
            </div>
          </div>
        </div>
        <div class="sendTime pb20 mb20" v-if="orderPreviewInfo.isCanChooseDeliveryWay">
          <div class="select arrive-time arrow-right" @click="toggleDeliveryProp">
            <span>配送方式</span>
            <div class="input-text" style="font-weight: 600">
              {{ deliveryWay || '未选择（必选）' }}
            </div>
          </div>
        </div>
        <!--外送广告位-->
        <div v-if="banners.length>0">
          <img :src="banners[0].imageUrl" @click="bannerJump(banners[0])" style="width:100%;height: 100%">
        </div>
      </div>
      <!--自提地址-->
      <div class="self-take" v-if="is_self_take_new == 1 && showSelf">
        <div class="address">
          <!--自提-->
          <div class="oneTab" v-if="is_self_take_new == 1 && (is_eat_in == 0 && is_take_out == 0)">
            <span style="font-size: .32rem;color: #333;font-weight: 600;">打包自提</span>
            <!--<span class="self-take-icon new-take-icon" style="position: initial;"></span>-->
          </div>
          <p>自提地点</p>
          <div class="flexrow" style="justify-content: space-between;margin-top: 0.2rem">
            <h3>{{ orderPreviewInfo.pickUpAddr }}</h3>
            <span class="check-map" @click="toCheckMap">查看</span>
          </div>
        </div>
        <div class="sendTime mb20 selt-take-time" id="inputPanel">
          <div class="border-box">
            <div class="select arrive-time" @click="toggleProp">
              <span>自提时间</span>
              <div class="input-text"><span>{{ selectDateName }}{{ selectTimeName }}</span><span
                class="arrow-right"></span></div>
            </div>
            <div class="split-line"></div>
            <div class="select arrive-time" style="padding-left: 0.2rem">
              <span>自提电话</span>
              <div v-if="selfTakeMp != '' && selfTakeMp != null && selfTakeMp != undefined" class="input-text"
                   @click="inputPhone(1)">
                <span>{{ selfTakeMp }}</span><span class="arrow-right"></span>
              </div>
              <div v-else class="input-text" @click="inputPhone(1)">
                <span>请输入手机号</span><span class="arrow-right"></span>
              </div>
            </div>
          </div>
        </div>
        <!--自提选择楼栋信息-->
        <div class="building fs-28" v-if="orderPreviewInfo.needBuild && orderPreviewInfo.needBuild == 1">
          <div class="flex-row-bc arrow-right" @click="toChoseBuilding()">
            <div class="color-gray">宿舍信息</div>
            <div v-if="showChoseBuilding" style="margin-right: .25rem; color: #787878">未选择（必选）</div>
            <div v-else style="margin-right: .25rem; color: #787878">
              {{ buildInfo[0].name }}-{{ buildInfo[1].name }}-{{ buildInfo[2].name }}
            </div>
          </div>
        </div>
        <div class="protocol">
          <span :class="['icon-agree', {'select': isSelect}]" @click="isAgreeProtocol"></span>同意<span
          @click="toCheckProtocol">《打包自提服务协议》</span>
        </div>
      </div>
      <!--堂食-->
      <div v-if="is_eat_in == 1 && showEat" class="eatBox self-take">
        <!--堂食-->
        <div class="oneTab" v-if="is_eat_in == 1 && (is_self_take_new == 0 && is_take_out == 0)">
          <span style="font-size: .32rem;color: #333;font-weight: 600;">堂食</span>
          <!--<span class="eat-in-icon" style="position: initial;"></span>-->
        </div>
        <div style="font-size: .32rem; color: #4a4a4a;" v-if="orderPreviewInfo.dineInShopTips">
          {{ orderPreviewInfo.dineInShopTips }}
        </div>
        <div class="tips-eat" v-if="orderPreviewInfo.dineInTips">{{ orderPreviewInfo.dineInTips }}</div>
        <div class="sendTime mb20 selt-take-time" id="inputPanel">
          <div class="border-box" style="display: flex; border-bottom: none;">
            <div class="select arrive-time" @click="toggleProp">
              <span>就餐时间</span>
              <div class="input-text"><span>{{ selectDateName }}{{ selectTimeName }}</span><span
                class="arrow-right"></span></div>
            </div>
            <div class="split-line"></div>
            <div class="select arrive-time" style="padding-left: 0.2rem">
              <span>预留电话</span>
              <div v-if="selfTakeMp != '' && selfTakeMp != null && selfTakeMp != undefined" class="input-text"
                   @click="inputPhone(2)">
                <span>{{ selfTakeMp }}</span><span class="arrow-right"></span>
              </div>
              <div v-else class="input-text" @click="inputPhone(2)">
                <span>请输入手机号</span><span class="arrow-right"></span>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="eat-line"></div>-->
        <!--        <div style="font-size: .24rem;color: #9B9B9B;margin-top: .18rem">-->
        <!--          <span style="display: inline-block; margin-right: 2.58rem">就餐时间</span>-->
        <!--          <span>预留电话</span>-->
        <!--        </div>-->
        <!--        <div style="font-size: .32rem; color: #4a4a4a;margin-top: .04rem">-->
        <!--          <span style="display: inline-block; margin-right: 2.2rem">立即就餐</span>-->
        <!--          <span>{{orderPreviewInfo.mobile}}</span>-->
        <!--          <span class="arrow-right" style="display: inline-block; width: .24rem; height: .2rem;"></span>-->
        <!--        </div>-->
      </div>
      <!--订单商品信息-->
      <div class="order-info">
        <h3 class="shop-name ellipse">{{ orderPreviewInfo.supplier_short_name }}</h3>
        <ul class="order-goods-list">
          <li v-for="item in orderPreviewInfo.right_goods" class="flexrow">
            <div class="flexrow" style="width: 70%;">
              <div class="goods-img" :style="{backgroundImage:'url(' + item.thumbnail+')'}"></div>
              <div class="goods-name-box flexcol" style="justify-content: space-between">
                <span class="goods-name ellipse">{{ item.good_name }}</span>
                <span class="goods-spec ellipse" v-if="item.specAttrStr">{{ item.specAttrStr }}</span>
                <span>x{{ item.number }}</span>
              </div>
            </div>
            <div class="flexrow" style="width: 30%;justify-content:flex-end; align-items: center"><span
              class='ori_price' v-if="item.ori_price">￥{{ item.ori_price }}</span><span>￥{{ item.price }}</span></div>
          </li>
        </ul>
        <div class="line" style="margin: .2rem 0"></div>
        <!--额外费用：打包费-->
        <div class="flex-row-bc" v-for="item in orderPreviewInfo.extraFeeList">
          <div :style="{color: item.titleColor}" @click="viewPackDesc()">
            {{ item.title }}
            <span style="font-size: .2rem;margin-left: .1rem;color: #999" v-if="item.subTitle">{{
                item.subTitle
              }}</span>
            <span class="icon-desc" v-if="item.jumpType == 500088">?</span>
          </div>
          <span :style="{color: item.valueColor}">{{ item.value }}</span>
        </div>
      </div>

      <div style="background: #fff;padding: 0.2rem 0.2rem 0;margin-bottom: 0.2rem">
        <!--<div class="price_info" >-->
        <!--<p>商品总价 <span class="fr">￥{{orderPreviewInfo.generalGoodsAmount}}</span></p>-->
        <!--<p v-if="orderPreviewInfo.extraFeeTitle && orderPreviewInfo.extraFee">-->
        <!--{{orderPreviewInfo.extraFeeTitle}} <span class="fr">￥{{orderPreviewInfo.extraFee}}</span>-->
        <!--</p>-->
        <!--<p v-if="orderPreviewInfo.oriPackingFee">-->
        <!--{{orderPreviewInfo.greenTax}} <span class="fr">￥{{orderPreviewInfo.oriPackingFee}}</span>-->
        <!--</p>-->
        <!--<p v-if="!orderPreviewInfo.oriPackingFee">{{orderPreviewInfo.greenTax}} <span class="fr">￥{{orderPreviewInfo.packing_fee}}</span></p>-->
        <!--<p style="margin-bottom: 0.3rem" v-if="(orderType==1 || orderType==3) && !orderPreviewInfo.oriDeliveryFee && orderPreviewInfo.delivery_fee > 0">服务费 <span class="fr">￥{{orderPreviewInfo.delivery_fee}}</span></p>-->
        <!--<p style="margin-bottom: 0.3rem" v-if="(orderType==1 || orderType==3) && orderPreviewInfo.oriDeliveryFee && orderPreviewInfo.oriDeliveryFee > 0">服务费 <span class="fr">￥{{orderPreviewInfo.oriDeliveryFee}}</span></p>-->

        <!--<p v-if="orderType==0">-->
        <!--配送费-->
        <!--<span class="fee-tips" v-if="orderPreviewInfo.stepDeliveryFeeTip" @click="showFeeTips = !showFeeTips">-->
        <!--<span class="box" v-if="showFeeTips">{{orderPreviewInfo.stepDeliveryFeeTip}}</span>-->
        <!--</span>-->
        <!--<span class="fr">￥{{orderPreviewInfo.delivery_fee}}</span>-->
        <!--</p>-->

        <!--<p style="margin-bottom: 0.3rem" v-if="orderType==0 && orderPreviewInfo.serviceFee">服务费 <span class="fr">￥{{orderPreviewInfo.serviceFee}}</span></p>-->

        <!--<p v-if="orderPreviewInfo.oriPackingFee">-->
        <!--<span>{{orderPreviewInfo.packingFeeReductionTitle}}</span>-->
        <!--<span style="font-size: .2rem;margin-left: .1rem;color: #999" v-if="orderPreviewInfo.packingFeeReductionSubTitle">{{orderPreviewInfo.packingFeeReductionSubTitle}}</span>-->
        <!--<span class="fr price">-￥{{orderPreviewInfo.packingFeeReduction}}</span>-->
        <!--</p>-->
        <!--<p style="margin-bottom: 0.3rem" v-if="(orderType==1 || orderType==3) && orderPreviewInfo.oriDeliveryFee">-->
        <!--{{orderPreviewInfo.deliveryFeeReductionTitle}}-->
        <!--<span class="color-gray" v-if="orderPreviewInfo.deliveryFeeReductionSubTitle" style="font-size: .2rem;margin-left: .1rem;color: #999">{{orderPreviewInfo.deliveryFeeReductionSubTitle}}</span>-->
        <!--<span class="fr price">-￥{{orderPreviewInfo.deliveryFeeReduction}}</span>-->
        <!--</p>-->
        <!--&lt;!&ndash;<p v-if="couponInfo != null">优惠券 <span class="fr settle-price">- ￥{{orderPreviewInfo.couponAmount}}</span></p>&ndash;&gt;-->
        <!--</div>-->
        <!--订单相关费用-->
        <div style="padding-bottom: .2rem;overflow: hidden" v-for="item in orderPreviewInfo.orderFeeList">
          <div class="flex-row-bc" :style="{color: item.titleColor}">
            <div>
              <div class="flex-row-sc" @click="showOrderFeeDesc(item)">
                {{ item.title }}
                <img v-if="item.isShowDesc && item.isShowDesc == 1" src="../assets/images/icon-shuoming@2x.png" alt="" style="display: inline-block;width: .26rem">
                <span v-if="item.showDesc" style="font-size: .18rem;padding: .02rem .1rem;border-radius: .12rem;background-color: #ddd;">{{item.desc}}</span>
              </div>
              <span style="font-size: .2rem;margin-left: .1rem;color: #999" v-if="item.subTitle">
                {{ item.subTitle }}
              </span>
            </div>
            <div>
              <span v-if="item.originValue" style="text-decoration: line-through;color: #999">
                {{ item.originValue }}
              </span>
              <span :style="{color: item.valueColor}" class="ml10">{{ item.value }}</span>
            </div>
          </div>
          <div v-if="item.isShowDirectDesc == 1" class="fs-20 mt10" style="color:#999;">{{item.directDesc}}</div>
        </div>
        <p class="line"></p>
        <!--满减-->
        <div class="activity reduction"
             v-if="orderPreviewInfo.reductionAmount && orderPreviewInfo.reductionAmount>0">满减优惠
          <span class="fr" style="color:#F2596C;">-￥{{ orderPreviewInfo.reductionAmount }}</span>
        </div>
        <!--满赠-->
        <div v-if="giftList.length == 1">
          <div class="activity special-goods arrow-right">
            <span>{{ orderPreviewInfo.gift_activity_name }}</span>
            <span class="fr red"
                  v-if="defaultGift.good_name.length < 10">{{ defaultGift.good_name }}x{{ defaultGift.number }}</span>
            <span class="fr red" v-else>{{ defaultGift.good_name.substring(0, 10) }}...x{{ defaultGift.number }}</span>
          </div>
        </div>
        <div v-if="giftList.length > 1" style="padding-bottom: 0">
          <div class="activity special-goods arrow-right" v-on:click="selectGift" v-bind:class="{'open':showMoreGift}">
            <div class="more">
              <span>{{ orderPreviewInfo.gift_activity_name }}</span>
              <span class="fr red"
                    v-if="defaultGift.good_name.length < 10">{{ defaultGift.good_name }}x{{ defaultGift.number }}</span>
              <span class="fr red"
                    v-else>{{ defaultGift.good_name.substring(0, 10) }}...x{{ defaultGift.number }}</span>
            </div>
          </div>
        </div>
        <!--配送券-->
        <div class="flex-row-bc arrow-right activity" @click="toSelectCoupon(2)" v-if="orderType == 0 && (orderPreviewInfo.deliveryFeeCoupons || orderPreviewInfo.unValidDeliveryFeeCoupons)">
          <span>配送券</span>
          <div v-if="JSON.stringify(defaultAddress) === '{}' && orderType == 0" style="color:#9B9B9B">请添加收货地址</div>
          <div v-else>
            <div v-if="orderPreviewInfo.deliveryFeeCoupons && orderPreviewInfo.canUseDeliveryFeeCouponNum > 0" class="red">
              <span v-if="orderPreviewInfo.deliveryFeeCouponId">- ￥{{ orderPreviewInfo.deliveryFeeCouponAmount }}</span>
              <div v-else>
                {{ orderPreviewInfo.canUseDeliveryFeeCouponNum}}张可用
                <span v-if="orderPreviewInfo.maxDeliveryFeeCouponAmount">，最高可减{{orderPreviewInfo.maxDeliveryFeeCouponAmount}}元</span>
              </div>
            </div>
            <span v-else style="color:#9B9B9B">无可用</span>
          </div>
        </div>
        <!--优惠券-->
        <div class="flex-row-bc arrow-right activity" @click="toSelectCoupon(1)">
          <span>优惠券</span>
          <div v-if="JSON.stringify(defaultAddress) === '{}' && orderType == 0" style="color:#9B9B9B">请添加收货地址</div>
          <div v-else>
            <div v-if="couponsList.length && orderPreviewInfo.canUseCouponNum > 0" class="red">
              <span v-if="couponInfo && couponInfo.amount">- ￥{{ orderPreviewInfo.couponAmount }}</span>
              <div v-else>
                {{ orderPreviewInfo.canUseCouponNum}}张可用
                <span v-if="orderPreviewInfo.maxCouponAmount">，最高可减{{orderPreviewInfo.maxCouponAmount}}元</span>
              </div>
            </div>
            <span v-else style="color:#9B9B9B">无可用</span>
          </div>
        </div>
        <!--结算-->
        <div class="activity" style="padding-right:0;border-bottom: none">
          <div class="flexrow" style="justify-content: flex-end">
            小计<span style="font-size: 0.32rem;color:#333;">￥{{ orderPreviewInfo.phaseSubtotal }}</span>
          </div>
        </div>
        <!--<div class="notice" style="color: #9b9b9b;padding: 0.2rem 0;border-top: 1px solid #f6f6f6;">温馨提示：赠品已经全部送完啦～</div>-->
        <div class="notice"
             v-if="orderPreviewInfo.gift_code == '-2'"
             style="color: #9b9b9b;padding: 0.2rem 0;border-top: 1px solid #f6f6f6;">
          温馨提示：赠品已经全部送完啦～
        </div>

      </div>
      <!-- 准时达 -->
      <div class="card marginB20" v-if="orderPreviewInfo.punctualArrive">
        <div class="flex-row-bc fs-28 fw-bold">
          <div class="flex-row-bc" :style="{color: orderPreviewInfo.punctualArrive.titleColor}">
            {{orderPreviewInfo.punctualArrive.title}}
            <img :src="orderPreviewInfo.punctualArrive.imgUrl" class="ml10" style="width: .5rem;" />
          </div>
          <div v-if="orderPreviewInfo.punctualArrive.changeAimed" class="flex-row-bc" :style="{color: orderPreviewInfo.punctualArrive.valueColor}" @click="changePunctualArrive()">
            {{orderPreviewInfo.punctualArrive.value}}
            <img v-if="orderPreviewInfo.punctualArrive.aimed" src="../assets/images/btn_choose@2x.png" class="ml10" style="width: .28rem;" />
            <img v-else src="../assets/images/btn_choose_default@2x.png" class="ml10" style="width: .28rem;" />
          </div>
          <div v-else class="flex-row-bc" :style="{color: orderPreviewInfo.punctualArrive.valueColor}">
            {{orderPreviewInfo.punctualArrive.value}}
            <img src="../assets/images/btn_choose@2x.png" class="ml10" style="width: .28rem;" />
          </div>
        </div>
        <div class="fc-999 fs-22 mt10" @click="viewPunctualArrive()">
          {{orderPreviewInfo.punctualArrive.desc}}
          <img src="../assets/images/icon-warning.png" style="display: inline-block;width: .24rem; vertical-align: middle" />
        </div>
      </div>
      <!--加价购-->
      <div class="order-info hikes" v-if="orderPreviewInfo.right_hikes && orderPreviewInfo.right_hikes.length"
           style="padding-bottom:0;">
        <h3 class="shop-name">超值换购</h3>
        <ul class="order-goods-list">
          <li v-for="item in orderPreviewInfo.right_hikes" class="flexrow">
            <div class="flexrow" style="width: 70%;">
              <div class="goods-img" :style="{backgroundImage:'url(' + item.thumbnail+')'}"></div>
              <div class="goods-name-box flexcol" style="justify-content: space-between">
                <span class="goods-name ellipse">{{ item.good_name }}</span>
                <span>￥{{ item.price }}</span>
              </div>
            </div>
            <div class="flexrow" style="width: 30%;justify-content:flex-end; align-items: center">
              <div v-if="item.maxNumber>0">
                <div class='add-goods-btn btn-yellow' v-show="!item.showHikes" @click="changeHikes(item)">加价购</div>
                <div class="operator-box flexrow" v-show="item.showHikes">
                  <span @click="subtractGoods(item)"
                        :class="['operatorBtn', 'minus',{'grey-minus':item.number==0}]"></span>
                  <span class="operatorBtn number">{{ item.number }}</span>
                  <span @click="addRefundGoods(item)"
                        :class="['operatorBtn','plus',{'grey-minus':item.number<item.maxNumber}]"></span>
                </div>
              </div>
              <div v-else class='add-goods-btn'>售罄</div>
            </div>
          </li>
        </ul>
        <div class="activity" style="padding-right:0;border-bottom: none;border-top:1px solid #f6f6f6;">
          <div class="flexrow" style="justify-content: flex-end">
            小计
            <span style="font-size: 0.32rem;color:#333;"
                  v-if="orderPreviewInfo.hikeSubTotal">￥{{ orderPreviewInfo.hikeSubTotal }}</span>
            <span style="font-size: 0.32rem;color:#333;" v-else>￥0</span>
          </div>
        </div>
      </div>
      <div class="list list-indent order">
        <ul>
          <li class="flexrow" style="align-items: center;justify-content:space-between;padding: 0 0.2rem;">
            <label style="font-size: 0.26rem">支付</label><span>在线支付</span>
          </li>
          <li>
            <div class="line"></div>
          </li>
          <li style="padding: 0 0.2rem;" v-if="orderType != 0">
            <label style="font-size: 0.26rem"><span v-if="showRemarks" style="color: #f2596c;">*</span>备注</label>
            <textarea v-model="remarks" maxlength="100" :placeholder="placeholder1" @input="changeComment()"
                      style="width:85%;height:1.2rem; margin-top: 0.2rem;border-radius: 0.1rem;padding: 0.1rem;font-size: 0.28rem"></textarea>
          </li>
        </ul>
      </div>
      <!--外送选择备注-->
      <div class="remarks-box fs-28"  v-if="is_take_out == 1 && showTake">
        <div class="arrow-right out-remarks" @click="toRemarks()">
          <div class="color-gray"><span v-if="showRemarks" style="color: #f2596c;">*</span>备注</div>
          <div v-if="remarks"
                style="max-width: 5.5rem; margin-right: .2rem; color: #787878;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            {{ remarks }}
          </div>
          <div v-if="placeholder && !remarks"
                style="max-width: 5.5rem; margin-right: .2rem; color: #787878;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            {{ placeholder }}
          </div>
        </div>
      </div>
      <!-- 购买券包 -->
      <div class="cpackage-title" v-if="orderPreviewInfo.canUseCouponNum === 0 && couponPackageList && couponPackageList.length == 1" style="margin:0">本单可用立减<span style="color:#FF4A61">{{couponPackageList[0].package_unit_price}}元</span></div>
      <div class="cpackage-list" v-if="orderPreviewInfo.canUseCouponNum === 0 && couponPackageList && couponPackageList.length > 0">
        <div class="item" v-for="(item, index) in couponPackageList" :key="index">
          <div style="display: flex">
            <div class="img">
              <div class="c-tit">{{ item.package_coupon_title }}</div>
              <div class="c-price">
                <span>{{ item.package_unit_price }}</span
                >元x<span>{{ item.package_unit_num }}</span
                >张
              </div>
              <div class="c-desc">{{ item.package_coupon_desc }}</div>
            </div>
            <div style="width: 3.2rem">
              <div class="name">{{ item.package_name }}</div>
              <div>{{ item.package_shop_desc }}</div>
              <div class="price">
                ¥<span>{{ item.package_selling_price }}</span>
              </div>
            </div>
          </div>
          <div class="btn-buy" :class="item.package_status === 0 ? 'disabled' : ''" @click="buyCouponPackage(item)">立即购买</div>
        </div>
      </div>
    </div>
    <!--满减满赠提示-->
    <div class="reduce_tips" v-if="orderPreviewInfo.gift_msg || orderPreviewInfo.reductionMsg">
      <p v-if="orderPreviewInfo.gift_msg && orderPreviewInfo.gift_msg != ''">{{ orderPreviewInfo.gift_msg }}</p>
      <p v-if="orderPreviewInfo.reductionMsg && orderPreviewInfo.reductionMsg != ''">
        {{ orderPreviewInfo.reductionMsg }}</p>
    </div>

    <!--底部固定栏-->
    <footer class="dark fixed flexrow">
      <div>
        <div class="footer-cart" v-if="(orderType == 0 || orderType == 3) && orderPreviewInfo.saveDiscount > 0 ">
          <span
            style="line-height: 1rem;font-size: 0.28rem; color: #333;">已优惠 ￥{{ orderPreviewInfo.saveDiscount }}</span>
        </div>
        <div class="footer-cart" v-else-if="(orderType == 0 || orderType == 3) && orderPreviewInfo.saveDiscount == 0 ">
          <span style="font-size: 0.28rem; color: #333; width: 1.7rem;height: 1rem"></span>
        </div>
        <div class="footer-cart flexcol" style="justify-content:center;"
            v-else-if="(orderType == 1 || orderType == 3) && orderPreviewInfo.saveDiscount > 0">
          <span style="font-size: 0.28rem; color: #333;">节省 ￥{{ totalSave }}</span>
          <span
            style="font-size: 0.24rem; color: #787878;">优惠{{
              orderPreviewInfo.saveDiscount
            }}+配送费{{ orderPreviewInfo.saveDeliveryFee }}</span>
        </div>
      </div>
      <div class="flexrow">
        <div class="footer-cart">
          <span class="price" style="line-height: 1rem;margin-right: 0.2rem">合计 <span
            style="font-weight: bold">￥{{ orderPreviewInfo.real_pay }}</span></span>
        </div>
        <div class="footer-cart flexcol" style="justify-content: center">
          <a @click="createOrder" class="btn btn-main" v-if="orderSubmitType==2 && isCanSubmit">提交订单</a>
          <a class="btn btn-gray" v-else>提交订单</a>
        </div>
      </div>
    </footer>
    <div class="mask" v-if="propShow" @click="toggleProp"></div>
    <div id="prop-box" class="prop-box time-list" v-if="propShow">
      <div class="title ac">{{ timeTitle }}</div>
      <div class="dineInLimitTips" v-if="orderPreviewInfo.dineInLimitTips && orderType == 3">
        {{ orderPreviewInfo.dineInLimitTips }}
      </div>
      <ul class="select-date">
        <li v-for="item in dateList" :class={active:item.isActive} @click="changeDate(item.delivery_date)"
            :key="item.delivery_date">{{ item.delivery_date_name }}
        </li>
      </ul>
      <ul class="select-time" @scroll=handleScroll>
        <li v-for="item in currentTimeList"
            @click="item.canSelected == 0 ? null : changeTime(item.delivery_time, item.delivery_time_name, item)"
            :class="{'canSelect':item.canSelected==0}">{{ item.delivery_time_name }}
        </li>
      </ul>
    </div>
    <div class="mask" v-if="deliveryPopup" @click="toggleDeliveryProp"></div>
    <div class="prop-box delivery-list" v-if="deliveryPopup">
      <div class="title ac">请选择配送方式</div>
      <div class="list">
        <div class="item flex-row-bc" v-for="item in orderPreviewInfo.deliveryWayList" @click="choseDelivery(item)">
          <div style="display: flex;flex-direction: column">
            <span style="font-size: 15px;" :class="!item.isCanSelect && item.upstairsDelivery == 1 ? 'fc-999' : ''">{{item.title}}</span>
            <span style="font-size: 11px" class="fc-999">{{item.subTitle}}</span>
            <span style="font-size: 11px;" class="fc-999">
            <span v-if="item.upstairsDelivery == 1">{{item.tip}}</span>
            </span>
          </div>
          <img style="width: .36rem;height: .36rem;" v-if="item.selected" src="../assets/images/icon_choose@2x.png" />
          <img style="width: .36rem;height: .36rem;" v-if="!item.selected" :class="!item.isCanSelect && item.upstairsDelivery == 1 ? 'opa-5' : ''" src="../assets/images/icon_choose_default.png"/>
        </div>
      </div>
    </div>
    <div class="gift-list " v-show="showMoreGift" @click="selectGift">
      <ul>
        <li class="title">可选赠品</li>
        <li class="select-item" v-for="item in giftList" v-on:click.stop="changeGift(item)"><span
          class="gift-name">{{ item.good_name }}x{{ item.number }}</span> <span class="icon icon-select"
                                                                                v-bind:class="{'on':item.is_selected == 1}"></span>
        </li>
      </ul>
    </div>
    <!--自提选择楼栋-->
    <div class="mask" v-if="showBuildingPop" @click="showBuildingPop = false"></div>
    <div class="prop-box" v-if="showBuildingPop">
      <!--<div class="title ac">选择楼栋信息</div>-->
      <ul class="building-title">
        <li v-for="(item,index) in buildInfo" :key="index" :class="{'checked':item.checked}"
            @click="changeBuildingTitle(item,index)">{{ item.name }}
        </li>
        <!--<li>楼层</li>-->
        <!--<li>房间号</li>-->
      </ul>
      <ul class="building-cnt">
        <li v-for="item in buildingList" :class="{'checked':item.checked}" @click="changeBuilding(item)">
          {{ item.area }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {actions} from '../store/actions'
import adminNative from '../assets/js/bridge'
import {callNative} from "../assets/js/bridge";
// import { Indicator, MessageBox, Toast } from 'mint-ui'

export default {
  data() {
    return {
      propShow: false,
      dateList: [],
      currentTimeList: [],
      orderPreviewInfo: {
        canSubmit: true,
        supplier_short_name: '',
        gift_code: 0,
        gift_url: ''
      },
      defaultAddress: {},  //默认地址信息
      comment: '',  //备注
      selectDateName: '',  //选择日期名字
      selectDate: '',  //选择日期
      selectTimeName: '',  //选择时间名字
      selectTime: '',  //选择时间
      selectTimeRange: '',
      timed: -1,
      createOrderId: 0,
      coupontext: '',
      discounttext: '',
      couponcount: 0,
      discount: 0,
      couponflag: false,
      discountflag: false,
      deliverSelectedtext: '',
      delivertext: '',
      delivertextvalue: '',
      bottomButtonShow: false,
      shopCode: window.localStorage.getItem('shop_code'),
      giftUrl: '',
      giftList: [],
      showMoreGift: false,
      defaultGift: {},
      couponInfo: JSON.parse(window.localStorage.getItem('selectedCoupon')),
      deliveryCouponInfo: JSON.parse(window.localStorage.getItem('selectedDeliveryCoupon')),
      orderOriginalInfo: {},
      couponsList: [],
      is_self_take_new_new: '', //是否支持自提，1是，0否
      is_take_out: '', //是否支持外送，1是，0否
      is_eat_in: '', //是否支持堂食，1是，0否
      isShow: false,
      showTake: true,
      showSelf: false,
      showEat: false,
      isSelect: true,
      orderType: 0,
      totalSave: '',
      selfTakeMp: '',
      timeTitle: '选择送达时间',
      isCanSubmit: true,//是否可以提交订单,
      orderSubmitType: 2,
      couponMobile: '',//预检：验证优惠券需要的电话
      hikes: [],//加价购商品列表,
      remarks: '',
      placeholder: '',
      placeholder1: '',
      showRemarks: false,
      banners: [],
      source: '',
      jdlwTokenStr: '',// 京东梨涡
      showFeeTips: false, // 显示配送费说明

      showChoseBuilding: true, // 自提楼栋
      showBuildingPop: false,
      buildInfo: [{id: ' ', name: '请选择', checked: true}, {id: ' ', checked: false}, {id: ' ', checked: false}],
      buildingList: [],
      pickUpAddress: {},

      schoolCardCode: '',

      couponPackageList: [], // 券包
      //楼层
      deliveryPopup: false,
      deliveryWay: '',
      upstairsDelivery: 0,
      versionAgreement: {},
      buyInsurance: null
    }
  },
  computed: {
    cartInfo() {
      return this.$store.state.cartInfo
    },
    schoolInfo() {
      return this.$store.state.schoolInfo
    },
    wxUid() {
      return this.$store.state.wxUid
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  mounted() {
    var weakThis = this;
    this.initSDKToken()
      .then(token => {
        const {sdkToken, sdkTokenError} = token
        console.log(token)
        weakThis.jdlwTokenStr = sdkToken
      })
      .catch(err => {
        console.error(err)
      })
  },
  created() {
    var _this = this;
    // document.title = '确认下单';
    if (window.localStorage.getItem('shopType') || window.localStorage.getItem('is_take_out') || window.localStorage.getItem('is_eat_in')) {
      _this.is_self_take_new = window.localStorage.getItem('shopType');
      _this.is_take_out = window.localStorage.getItem('is_take_out');
      _this.is_eat_in = window.localStorage.getItem('is_eat_in');

      if (_this.is_take_out == 1) {
        _this.orderType = 0;//外卖
      } else if (_this.is_self_take_new == 1 && (_this.is_take_out == 0 && _this.is_eat_in == 0)) {
        _this.orderType = 1;//仅自提
      } else if (_this.is_eat_in == 1 && (_this.is_self_take_new == 0 && _this.is_take_out == 0)) {
        _this.orderType = 3;//仅堂食
      } else if ((_this.is_self_take_new == 1 && _this.is_eat_in == 1) && _this.is_take_out == 0) {
        _this.orderType = 1;//自提+堂食
      }
    }

    if (window.localStorage.getItem('order-type')) {//订单类型 0-配送单，1-自提单，2-西游侠打赏订单，3-堂食订单
      _this.orderType = window.localStorage.getItem('order-type')
    }
    // console.log(_this.orderType)
    if (_this.orderType == 0) {
      _this.isShow = true
      _this.showTake = true
      _this.showSelf = false
      _this.showEat = false
      _this.timeTitle = '选择送达时间'
    } else if (_this.orderType == 1) {
      _this.showSelf = true
      _this.isShow = false
      _this.showTake = false
      _this.showEat = false
      _this.timeTitle = '选择取货时间'
    } else {
      _this.isShow = false
      _this.showTake = false
      _this.showSelf = false
      _this.showEat = true
      _this.timeTitle = '选择就餐时间'

    }
    if (window.localStorage.getItem("chooseAddress")) {
      _this.defaultAddress = JSON.parse(window.localStorage.getItem("chooseAddress"))
      // _this.defaultAddress.mp = _this.$utils.Decrypt(_this.defaultAddress.mp_encryption)
      _this.defaultAddress.mp_real = _this.$utils.Decrypt(_this.defaultAddress.mp_encryption)
      // _this.defaultAddress.addressee = _this.$utils.Decrypt(_this.defaultAddress.addressee_encryption)
    }
    // console.log(_this.defaultAddress)
    if (window.localStorage.getItem('orderPreviewType') == 1) {
      if (window.localStorage.getItem('orderPreviewInfo')) {
        let orderPreviewInfo = JSON.parse(window.localStorage.getItem('orderPreviewInfo'));
        if (orderPreviewInfo.right_hikes && orderPreviewInfo.right_hikes.length > 0) {//加价购
          for (let item of orderPreviewInfo.right_hikes) {
            item.showHikes = false;
          }
        }
        // 多规格
        for (let item of orderPreviewInfo.right_goods) {
          if (item.specification) {
            let AttrStr = [];
            if (item.attributes && item.attributes.length > 0) {
              for (let item2 of item.attributes) {
                for (let item3 of item2.attributeList) {
                  AttrStr.push(item3.name)
                }
              }
              item.specAttrStr = item.specification.name + '/' + AttrStr.join('/')
            } else {
              item.specAttrStr = item.specification.name
            }
          } else {
            let AttrStr = [];
            if (item.attributes && item.attributes.length > 0) {
              for (let item2 of item.attributes) {
                for (let item3 of item2.attributeList) {
                  AttrStr.push(item3.name)
                }
              }
              item.specAttrStr = AttrStr.join('/')
            }
          }

        }

        if(orderPreviewInfo.orderFeeList && orderPreviewInfo.orderFeeList.length > 0){
          for(let v of orderPreviewInfo.orderFeeList){
            if(v.isShowDesc && v.isShowDesc === 1){
              v.showDesc = false;
            }
          }
        }

        _this.orderPreviewInfo = orderPreviewInfo;
        _this.couponsList = _this.orderPreviewInfo.coupons || [];
        if(_this.orderPreviewInfo.promotionCouponPackageBeanList && _this.orderPreviewInfo.promotionCouponPackageBeanList.length > 0){
          _this.getCouponPackageList();
        }
        _this.havePickUpTime = _this.orderPreviewInfo.havePickUpTime
        if (_this.orderPreviewInfo.saveDiscount > 0) {
          _this.totalSave = parseFloat(_this.orderPreviewInfo.saveDiscount) + parseFloat(_this.orderPreviewInfo.saveDeliveryFee);
          _this.totalSave = _this.totalSave.toFixed(2)
        }

        var cansubmit = window.localStorage.getItem('canSubmit')
        if (cansubmit) {
          if (cansubmit == 1) {
            _this.orderSubmitType = 1;
            _this.orderPreviewInfo.canSubmit = false
          } else {
            _this.orderSubmitType = 2;
            _this.orderPreviewInfo.canSubmit = true
          }
        } else {
          if (_this.orderPreviewInfo.canSubmit == undefined) {
            _this.orderPreviewInfo.canSubmit = true
            _this.orderSubmitType = 2;
          }
        }
        if (_this.orderPreviewInfo.gift_goods != undefined && _this.orderPreviewInfo.gift_goods.length > 0) {
          _this.giftList = _this.orderPreviewInfo.gift_goods;
          _this.defaultGift = _this.giftList[0];
        }
        if (window.localStorage.getItem('date')) {//有已选时间
          var dataObj = JSON.parse(window.localStorage.getItem('date')) //已选时间
          var dataListObj = JSON.parse(window.localStorage.getItem('dateList'))
          _this.dateList = dataListObj;
          for (var i = 0; i < _this.dateList.length; i++) {
            if (_this.dateList[i].isActive == true) {
              _this.currentTimeList = _this.dateList[i].delivery_TimeList;
              _this.selectDateName2 = _this.dateList[i].delivery_date_name;
              _this.selectDate2 = _this.dateList[i].delivery_date;
            }
          }
          _this.selectDate = dataObj.selectDate;
          _this.selectDateName = dataObj.selectDateName;
          _this.selectTime = dataObj.selectTime;
          _this.selectTimeRange = dataObj.selectTimeRange;
          _this.selectTimeName = dataObj.selectTimeName;
        } else {
          if (_this.orderPreviewInfo.is_in_business == 1 && _this.orderType != 0) {
            _this.selectDateName = '未选择（必选）';
            _this.selectDate = '';
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectTimeName = '';
            _this.selectTime = '';
            _this.selectTimeRange = '';
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          } else if (_this.orderPreviewInfo.is_in_business == 1 && _this.orderType == 0) {
            _this.selectDateName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectTimeName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_name;
            _this.selectTime = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time;
            _this.selectTimeRange = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_range;
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          } else {
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDateName = '未选择（必选）';
            _this.selectDate = '';
            _this.selectTimeName = '';
            _this.selectTime = '';
            _this.selectTimeRange = '';
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          }
          _this.dateList = _this.orderPreviewInfo.deliveryDateTimeList;
        }
        if(_this.orderPreviewInfo.isCanChooseDeliveryWay && _this.orderPreviewInfo.deliveryWayList.length > 0){
          for(let k of _this.orderPreviewInfo.deliveryWayList){
            if(k.selected){
              _this.deliveryWay = k.title
              _this.upstairsDelivery = k.upstairsDelivery
            }
          }
        }
        _this.giftUrl = _this.orderPreviewInfo.gift_url;
      }
      if (window.localStorage.getItem('selfTakeMp')) {
        _this.selfTakeMp = window.localStorage.getItem('selfTakeMp')
      }
      if (_this.orderPreviewInfo.canSubmit) {
        let ment = window.localStorage.getItem('shop_comment');
        if (ment && ment != '') {
          _this.comment = ment;
        }
      }
      if (_this.orderPreviewInfo.needBuild && _this.orderPreviewInfo.needBuild == 1) {
        _this.getBuildInfo();
      }
    } else if (window.localStorage.getItem('orderPreviewType') == 2) {
      _this.postDefaultAddress();//获取默认地址
    }

    //订单备注
    let uerRemarks = window.localStorage.getItem('remarks')
    // console.log(_this.orderPreviewInfo);
    if(uerRemarks){
      if(_this.orderPreviewInfo.isOrderRemark){
        _this.showRemarks = true;
      }else{
        _this.showRemarks = false;
      }
      _this.remarks = uerRemarks
      _this.placeholder = '';
      _this.placeholder1 = '';
    }else if(_this.orderPreviewInfo.isOrderRemark && !uerRemarks){
      _this.placeholder = _this.orderPreviewInfo.orderRemarkList ? _this.orderPreviewInfo.orderRemarkList : '请填写口味偏好';
      _this.placeholder1 = _this.orderPreviewInfo.orderRemarkColumn ? _this.orderPreviewInfo.orderRemarkColumn : '请填写口味偏好，推荐无接触配送，将商品放在楼下或寝室门口～';
      _this.showRemarks = true;
      _this.remarks = ''
    }else{
      _this.showRemarks = false;
      _this.remarks = ''
      _this.placeholder = '请填写口味偏好';
      _this.placeholder1 = '请填写口味偏好，推荐无接触配送，将商品放在楼下或寝室门口～';
    }

    // 打包费说明
    if (_this.orderPreviewInfo && _this.orderPreviewInfo.extraFeeList && _this.orderPreviewInfo.extraFeeList.length > 0 && _this.orderPreviewInfo.extraFeeList[0].jumpType == 500088) {
      localStorage.removeItem('packingFeeDetail');
      let packingFeeDetail = _this.orderPreviewInfo.extraFeeList[0].jumpParam;
      localStorage.setItem('packingFeeDetail', packingFeeDetail);
    }
    if (_this.orderPreviewInfo && _this.orderPreviewInfo.punctualArrive && _this.orderPreviewInfo.punctualArrive.changeAimed) {
      _this.getUserAgreement()
    }
    _this.banners = []
    _this.getBanner()
    _this.source = _this.$utils.getCookie('source') ? _this.$utils.getCookie('source') : null
  },
  // beforeRouteEnter(to, from, next){
  //   if(from.name == 'Payment') {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
  methods: {
    // 梨涡
    initSDKToken() {
      return callNative("jsGetRiskControlToken", null, {timeout: 2400})
    },
    //外送广告位
    getBanner: function () {
      var _this = this
      var url
      let host = _this.$utils.getSpliceHost('adsvc')
      url = host + '/ad/app/getList.do'
      var params = {
        app_version: "5.3",
        client_type: 3,
        device_id: "123",
        time: new Date().getTime(),
        schoolId: _this.schoolInfo.schoolId,
        locationId: "124"
      }
      _this.$http.post(url, params).then(function (response) {
        _this.banners = response.data.data.list
        // 响应成功回调
      }, function (response) {
        // _this.alert(response.message)
        // 响应错误回调
      })
    },
    bannerJump: function (item) {
      var _this = this
      if (item.data && item.data != '{}') {
        var jump = JSON.parse(item.data)
        if (jump.isNeedLogin) {
          var uid = _this.$store.state.wxUid
          if (uid == 'null' || uid == '' || uid == null) { // 如果没有登录信息先跳转登录页
            // _this.$router.push({name: 'Login'})
            _this.$utils.toLogin(_this);
          }
        }
        if (item.type === 500072) {
          var obj = {
            category_name: jump.key_title,
            tag_id: jump.key_id,
            shopListType: 'tag'
          }
          _this.$store.commit('changeState', obj)
          this.$router.push({name: 'ShopList'})
        } else if (item.type === 1022) {
          if (jump.url != '' && jump.url != null && jump.url != 'undefined') {
            window.location.href = jump.url
          }
        }
      }
    },
    //添加备注
    toRemarks() {
      this.$router.push({name: 'OutRemarks'})
    },
    changeHikes(item) {
      window.localStorage.removeItem('isSelectedCoupon');
      for (let obj of this.orderPreviewInfo.right_hikes) {
        if (obj.goods_sale_id == item.goods_sale_id) {
          obj.showHikes = true;
          obj.number = 1;
          window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo))
        }
      }
      this.secondCalculate();
    },
    addRefundGoods: function (item) {
      window.localStorage.removeItem('isSelectedCoupon');
      for (let obj of this.orderPreviewInfo.right_hikes) {
        if (obj.goods_sale_id == item.goods_sale_id) {
          if (obj.number < obj.maxNumber) {
            obj.number++;
            window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo))
            this.secondCalculate();
          }
        }
      }
    },
    subtractGoods: function (item) {
      window.localStorage.removeItem('isSelectedCoupon');
      for (let obj of this.orderPreviewInfo.right_hikes) {
        if (obj.goods_sale_id == item.goods_sale_id) {
          if (obj.number > 1) {
            obj.number--;
          } else {
            obj.number = 0
            obj.showHikes = false;
          }
          window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo))
          this.secondCalculate();

        }
      }
    },
    // 监听滑动
    handleScroll(e) {
      // console.log(e.target.scrollTop,'888')
    },
    // 切换配送方式
    switchStatus: function (status) {
      var _this = this
      window.localStorage.removeItem('isSelectedCoupon');
      if (_this.isCanSubmit) {
        if (status === 'take-away') {
          if (!_this.showTake) {
            _this.$toast({
              message: '因为您选择外卖配送，配送费已改变',
              duration: 2000
            });
            _this.timeTitle = '选择送达时间'
            _this.showTake = true
            _this.showSelf = false
            _this.showEat = false
            _this.isShow = true
            _this.orderType = 0//配送
            // window.localStorage.removeItem('selectedCoupon')
            // _this.couponInfo = JSON.parse(window.localStorage.getItem('selectedCoupon'))
            // _this.isCanSubmit = false
            // window.localStorage.removeItem('date') //已选时间
            // window.localStorage.removeItem('dateList')
            _this.postDefaultAddress()
          } else {
            return false;
          }
        } else if (status === 'take-self') {
          if (!_this.showSelf) {
            if (_this.orderPreviewInfo.havePickUpTime == 1) {
              _this.timeTitle = '选择取货时间'
              _this.showSelf = true
              _this.showTake = false
              _this.showEat = false
              _this.isShow = false
              _this.orderType = 1//字体
              // window.localStorage.removeItem('selectedCoupon')
              // _this.couponInfo = JSON.parse(window.localStorage.getItem('selectedCoupon'))
              // _this.isCanSubmit = false
              // window.localStorage.removeItem('date') //已选时间
              // window.localStorage.removeItem('dateList')
              // _this.postDefaultAddress()
            } else {
              _this.$messagebox.alert('当前时段不支持自提', '');
              _this.isCanSubmit = true
            }
          } else {
            return false;
          }
        } else if (status === 'take-eat') {
          if (!_this.showshowEatSelf) {
            _this.timeTitle = '选择就餐时间'
            _this.showEat = true
            _this.showTake = false
            _this.showSelf = false
            _this.orderType = 3//堂食
            _this.isShow = false
          } else {
            return false;
          }
        }
        window.localStorage.removeItem('selectedCoupon')
        window.localStorage.removeItem('selectedDeliveryCoupon')
        _this.couponInfo = JSON.parse(window.localStorage.getItem('selectedCoupon'))
        _this.deliveryCouponInfo = {};
        _this.isCanSubmit = false
        window.localStorage.removeItem('date') //已选时间
        window.localStorage.removeItem('dateList')
        _this.postDefaultAddress()
        window.localStorage.setItem('order-type', _this.orderType)
      } else {
        return false;
      }

    },
    inputPhone(val) {
      this.$messagebox({
        title: '',
        $type: 'prompt',
        message: val == 1 ? '请输入自提电话' : '请输入预留电话',
        inputPattern: /^1\d{10}$/,
        inputErrorMessage: '请输入正确的手机号',
        inputValue: this.selfTakeMp,
        showCancelButton: true,
        showInput: true
      }).then(({value, action}) => {
        window.localStorage.setItem('userDefinedMobile', value)
        this.selfTakeMp = value
        this.couponMobile = value
        window.localStorage.setItem('selfTakeMp', this.selfTakeMp)
        this.secondCalculate();
      })
    },
    // 查看地图
    toCheckMap: function () {
      window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo))
      window.localStorage.setItem('order-type', this.orderType)//查看完地图返回显示自提页面
      window.localStorage.setItem('mapAddr', this.orderPreviewInfo.pickUpAddr)
      window.localStorage.setItem('mapPic', this.orderPreviewInfo.pickUpImage);
      this.$router.push({name: 'Map'})
    },
    toCheckProtocol: function () {
      window.localStorage.setItem('order-type', this.orderType)
      window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo))
      this.$router.push({name: 'SelfTakeProtocol'})
    },
    isAgreeProtocol: function () {
      this.isSelect = !this.isSelect
    },
    //切换日期
    changeDate: function (id) {
      var _this = this
      var dateList = _this.dateList;
      for (var i = 0; i < dateList.length; i++) {
        if (dateList[i].delivery_date === id) {
          dateList[i].isActive = true;
          _this.selectDate2 = dateList[i].delivery_date;
          _this.selectDateName2 = dateList[i].delivery_date_name;
          _this.currentTimeList = dateList[i].delivery_TimeList
        } else {
          dateList[i].isActive = false
        }
      }
      _this.dateList = dateList
      document.getElementsByClassName('select-time')[0].scrollTop = 0
    },
    inputFocus: function () {
      document.getElementsByTagName('footer')[0].classList.remove('fixed')
    },
    inputBlur: function () {
      document.getElementsByTagName('footer')[0].classList.add('fixed')
    },
    // 获取用户默认地址
    postDefaultAddress: function () {
      var _this = this;
      actions.postDefaultAddress(_this, {school_id: this.$store.state.schoolInfo.schoolId}, function (data) { // 未设置默认地址的时候，返回的是最新地址
        console.log('---- 获取用户默认地址 ----')
        console.log(data)
        console.log('---- 获取用户默认地址 ----')
        if (data && data.mp) {
          _this.defaultAddress = data
          _this.defaultAddress.mp_real = _this.$utils.Decrypt(_this.defaultAddress.mp_encryption)
          if (window.localStorage.getItem('userDefinedMobile')) {
            _this.selfTakeMp = window.localStorage.getItem('userDefinedMobile')
          } else {
            _this.selfTakeMp = _this.defaultAddress.mp_real
          }
          window.localStorage.setItem('chooseAddress', JSON.stringify(data))
        } else {
          // console.log(data)
          // data.mp = _this.$utils.Decrypt(data.mp_encryption);
          // data.addressee = _this.$utils.Decrypt(data.addressee_encryption);
          if (window.localStorage.getItem('userDefinedMobile')) {
            _this.selfTakeMp = window.localStorage.getItem('userDefinedMobile')
          } else {
            _this.selfTakeMp = _this.$store.state.userInfo.mp;
            console.log(_this.$store.state.userInfo.mp_real)
          }
          window.localStorage.removeItem("chooseAddress")
        }
        // if(_this.orderType == 0){
        //   _this.couponMobile = _this.defaultAddress.mp_real
        // }else{
        //   _this.couponMobile = _this.selfTakeMp
        // }
        _this.couponMobile = _this.selfTakeMp
        window.localStorage.setItem('selfTakeMp', _this.selfTakeMp)
        _this.secondCalculate();
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      })
    },
    toggleProp: function () {
      var _this = this
      _this.propShow = !_this.propShow
    },
    toggleDeliveryProp: function () {
      var _this = this
      _this.deliveryPopup = !_this.deliveryPopup
    },
    choseDelivery(item){
      var _this = this
      var list = _this.orderPreviewInfo.deliveryWayList
      if(item.isCanSelect){
        for(let k of list){
          if(k.upstairsDelivery == item.upstairsDelivery){
            k.selected = 1
          }else{
            k.selected = 0
          }
        }
        _this.upstairsDelivery = item.upstairsDelivery
        _this.deliveryPopup = false
        _this.orderPreviewInfo.deliveryWayList = list
        _this.deliveryWay = item.title
        this.secondCalculate()
      }else{
        _this.$messagebox({
          title: '',
          message: item.reason,
          showCancelButton: false
        })
      }
    },
    jumpToaddress: function () {
      window.localStorage.setItem('shop_comment', this.comment);
      window.localStorage.setItem('fromPage', 'OrderSettle');
      this.$router.push({path: '/addresslist'})
    },
    // 更改配送时间
    changeTime: function (time, name, item) {
      if (time != -1) {
        var _this = this;
        _this.selectDate = _this.selectDate2;
        _this.selectDateName = _this.selectDateName2;
        _this.selectTime = time;
        _this.selectTimeName = name;
        if(item.delivery_time_range){
          _this.selectTimeRange = item.delivery_time_range;
        }
        _this.toggleProp()
        var obj = {
          selectDate: _this.selectDate,
          selectDateName: _this.selectDateName,
          selectTime: _this.selectTime,
          selectTimeName: _this.selectTimeName,
          selectTimeRange: _this.selectTimeRange
        }
        window.localStorage.setItem('date', JSON.stringify(obj))
        window.localStorage.setItem('dateList', JSON.stringify(_this.dateList))
        this.secondCalculate()
      }
    },
    changeGift: function (item) {
      var _this = this;
      for (var i = 0; i < _this.giftList.length; i++) {
        if (item.goods_sale_id == _this.giftList[i].goods_sale_id) {
          _this.giftList[i].is_selected = 1
        } else {
          _this.giftList[i].is_selected = 0
        }
      }
      _this.defaultGift = item;
      _this.showMoreGift = false;

    },
    selectGift: function () {
      var _this = this;
      _this.showMoreGift = !_this.showMoreGift
    },
    //选择优惠券
    toSelectCoupon: function (flag) {
      if (this.orderType == 0) {//外卖
        if (JSON.stringify(this.defaultAddress) === '{}') {
          this.$messagebox.alert('请添加收货地址', '')
        } else {
          this.selectCoupon(flag);
        }
      } else {
        this.selectCoupon(flag);
      }
    },
    selectCoupon: function (flag) {
      let _this = this;
      window.localStorage.removeItem('couponList');
      window.localStorage.removeItem('unValidCoupons');
      if (_this.orderOriginalInfo.canSubmit == undefined) {
        _this.orderOriginalInfo.canSubmit = true
        window.localStorage.setItem('canSubmit', 2)
        _this.orderSubmitType = 2;
      } else if (_this.orderOriginalInfo.canSubmit == false) {
        window.localStorage.setItem('canSubmit', 1)
        _this.orderSubmitType = 1;
      } else if (_this.orderOriginalInfo.canSubmit == true) {
        window.localStorage.setItem('canSubmit', 2)
        _this.orderSubmitType = 2;
      }


      window.localStorage.setItem('order-type', _this.orderType)
      if(flag == 1){
        if (_this.orderPreviewInfo.coupons) {
          var objStr = JSON.stringify(_this.orderPreviewInfo.coupons)
          window.localStorage.setItem('couponList', objStr);
        }
        ;
        if (_this.orderPreviewInfo.unValidCoupons) {
          var objStr2 = JSON.stringify(_this.orderPreviewInfo.unValidCoupons)
          window.localStorage.setItem('unValidCoupons', objStr2);
        }
        _this.$router.push({path: '/selectcoupon/1'})
      }else if(flag == 2){
        if (_this.orderPreviewInfo.deliveryFeeCoupons) {
          var objStr = JSON.stringify(_this.orderPreviewInfo.deliveryFeeCoupons)
          window.localStorage.setItem('deliveryFeeCoupons', objStr);
        }
        ;
        if (_this.orderPreviewInfo.unValidDeliveryFeeCoupons) {
          var objStr2 = JSON.stringify(_this.orderPreviewInfo.unValidDeliveryFeeCoupons)
          window.localStorage.setItem('unValidDeliveryFeeCoupons', objStr2);
        }
        _this.$router.push({path: '/selectcoupon/2'})
      }

      if (_this.orderPreviewInfo.right_hikes && _this.orderPreviewInfo.right_hikes.length > 0) {
        _this.hikes = [];
        for (let item of _this.orderPreviewInfo.right_hikes) {
          if (item.number > 0) {
            _this.hikes.push(item)
          }
        }
        window.localStorage.setItem('hikes', JSON.stringify(_this.hikes))
      }
    },
    // 二次预检
    secondCalculate: function () {
      var _this = this
      _this.orderOriginalInfo = JSON.parse(window.localStorage.getItem('orderPreviewInfo'))
      var cansubmit = window.localStorage.getItem('canSubmit')
      if (cansubmit) {
        if (cansubmit == 1) {
          _this.orderSubmitType = 1;
          _this.orderOriginalInfo.canSubmit = false
        } else {
          _this.orderSubmitType = 2;
          _this.orderOriginalInfo.canSubmit = true
        }
      } else {
        if (_this.orderOriginalInfo.canSubmit == undefined) {
          _this.orderOriginalInfo.canSubmit = true
          _this.orderSubmitType = 2;
        }
      }
      var goodsList = _this.orderOriginalInfo.right_goods
      var goods = []
      for (var i = 0; i < goodsList.length; i++) {
        goods[i] = {
          goods_sale_id: goodsList[i].goods_sale_id,
          number: goodsList[i].number,
          original_price: goodsList[i].ori_price,
          price: goodsList[i].price
        }
        if(goodsList[i].attributePrice || goodsList[i].attributePrice === 0){
          goods[i].attributePrice = goodsList[i].attributePrice;
        }
        if (goodsList[i].specification) {
          goods[i].specification = goodsList[i].specification
        }
        if (goodsList[i].attributes) {//属性
          goods[i].attributes = goodsList[i].attributes;
        }
      }
      for (var i = 0; i < goods.length; i++) {
        if (goods[i].original_price === undefined) {
          delete goods[i].original_price
        }
      }
      let hikes = [], isSelectedCoupon;//加价购
      if (window.localStorage.getItem('isSelectedCoupon')) {
        isSelectedCoupon = window.localStorage.getItem('isSelectedCoupon');
      } else {
        isSelectedCoupon = false;
      }
      if (isSelectedCoupon) {//选择优惠券后预检
        if (window.localStorage.getItem('hikes')) {
          _this.hikes = JSON.parse(window.localStorage.getItem('hikes'))
          if (_this.hikes && _this.hikes.length > 0) {
            for (let item of _this.hikes) {
              if (item.number > 0) {
                hikes.push(item)
              }
            }
          }
        }
      } else {//非选择优惠券后预检
        if (_this.orderOriginalInfo.right_hikes && _this.orderOriginalInfo.right_hikes.length > 0) {
          for (let item of _this.orderOriginalInfo.right_hikes) {
            if (item.number > 0) {
              hikes.push(item)
            }
          }
        }
      }
      // console.log(goods)
      var params = {
        school_id: _this.schoolInfo.schoolId,
        supplier_id: _this.orderOriginalInfo.supplier_id,
        supplier_short_name: _this.orderOriginalInfo.supplier_short_name,
        goods: goods,
        hikes: hikes,
        // client_type: 7,
        orderType: _this.orderType, //1支持自提，0不支持自提
        mobile: _this.couponMobile
      }
      // 如果有默认地址，传默认地址经纬度
      let chooseAddress = window.localStorage.getItem('chooseAddress')
      if(chooseAddress){
        if (JSON.parse(chooseAddress).isLimitFloor) {
          params.buildingId = JSON.parse(chooseAddress).build_id;
          params.building = JSON.parse(chooseAddress).build_name;
          params.floorId = JSON.parse(chooseAddress).floor_id;
          params.floor = JSON.parse(chooseAddress).floor_name;
          params.roomId = JSON.parse(chooseAddress).room_id;
          params.room = JSON.parse(chooseAddress).room_name;
          params.isSelectAddress = 1;
        } else {
          params.isSelectAddress = 1
          params.address_lng = JSON.parse(chooseAddress).lon
          params.address_lat = JSON.parse(chooseAddress).lat
        }
      }
      if (_this.couponInfo) {//选择了优惠券
        params.user_coupon_id = _this.couponInfo.user_coupon_id
      }
      if (_this.deliveryCouponInfo && _this.deliveryCouponInfo.user_coupon_id) {//选择了优惠券
        params.deliveryFeeUserCouponId = _this.deliveryCouponInfo.user_coupon_id
        params.isUseDeliveryFeeCoupon = true
      }else{
        params.isUseDeliveryFeeCoupon = false
      }
      params.upstairsDelivery = _this.upstairsDelivery
      if(_this.selectDate){
        params.delivery_date = _this.selectDate
      }
      if(_this.selectTime){
        params.delivery_time = _this.selectTime
      }
      if(_this.selectTimeRange){
        params.delivery_time_range = _this.selectTimeRange
      }
      if(_this.buyInsurance){
        params.buyInsurance = _this.buyInsurance;
      }
      actions.postOrderPreview(_this, params, function (data) {
        data.canSubmit = _this.orderOriginalInfo.canSubmit
        if (data.right_hikes) {
          for (let item of data.right_hikes) {
            if (item.number > 0) {
              item.showHikes = true;
            } else {
              item.showHikes = false;
            }
          }
        }

        // 多规格
        for (let item of data.right_goods) {
          if (item.specification) {
            let AttrStr = [];
            if (item.attributes && item.attributes.length > 0) {
              for (let item2 of item.attributes) {
                for (let item3 of item2.attributeList) {
                  AttrStr.push(item3.name)
                }
              }
              item.specAttrStr = item.specification.name + '/' + AttrStr.join('/')
            } else {
              item.specAttrStr = item.specification.name
            }
          } else {
            let AttrStr = [];
            if (item.attributes && item.attributes.length > 0) {
              for (let item2 of item.attributes) {
                for (let item3 of item2.attributeList) {
                  AttrStr.push(item3.name)
                }
              }
              item.specAttrStr = AttrStr.join('/')
            }
          }
        }
        if(data.orderFeeList && data.orderFeeList.length > 0){
          for(let v of data.orderFeeList){
            if(v.isShowDesc && v.isShowDesc == 1){
              v.showDesc = false;
            }
          }
        }
        _this.orderPreviewInfo = data
        _this.couponsList = _this.orderPreviewInfo.coupons || []
        if (_this.orderPreviewInfo.saveDiscount > 0) {//优惠后的价格
          _this.totalSave = parseFloat(_this.orderPreviewInfo.saveDiscount) + parseFloat(_this.orderPreviewInfo.saveDeliveryFee);
          _this.totalSave = _this.totalSave.toFixed(2);
        }
        if (_this.orderPreviewInfo.gift_goods != undefined && _this.orderPreviewInfo.gift_goods.length > 0) {//有赠品
          _this.giftList = _this.orderPreviewInfo.gift_goods;
          _this.defaultGift = _this.giftList[0];
        }
        if (window.localStorage.getItem('date')) {
          var dataObj = JSON.parse(window.localStorage.getItem('date')) //已选时间
          var dataListObj = JSON.parse(window.localStorage.getItem('dateList'))
          _this.dateList = dataListObj;
          for (var i = 0; i < _this.dateList.length; i++) {
            if (_this.dateList[i].isActive == true) {
              _this.currentTimeList = _this.dateList[i].delivery_TimeList;
              _this.selectDateName2 = _this.dateList[i].delivery_date_name;
              _this.selectDate2 = _this.dateList[i].delivery_date;
            }
          }
          _this.selectDate = dataObj.selectDate;
          _this.selectDateName = dataObj.selectDateName;
          _this.selectTime = dataObj.selectTime;
          _this.selectTimeRange = dataObj.selectTimeRange;
          if(_this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList &&
            _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time == 0 &&
            dataObj.selectTime == 0){
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList
            _this.dateList[0].delivery_TimeList = _this.currentTimeList
            _this.selectDateName2 = _this.dateList[0].delivery_date_name;
            _this.selectDate2 = _this.dateList[0].delivery_date;
            _this.selectTimeName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_name;
          }else{
            _this.selectTimeName = dataObj.selectTimeName;
          }
        } else {//没有选择过时间
          _this.dateList = _this.orderPreviewInfo.deliveryDateTimeList;
          for (var i = 0; i < _this.dateList.length; i++) {
            if (i === 0) {
              _this.dateList[i].isActive = true
            } else {
              _this.dateList[i].isActive = false
            }
          }
          if (_this.orderPreviewInfo.is_in_business == 1 && _this.orderType != 0) {
            _this.selectDateName = '未选择（必选）';
            _this.selectDate = '';
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectTimeName = '';
            _this.selectTime = '';
            _this.selectTimeRange = '';
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          } else if (_this.orderPreviewInfo.is_in_business == 1 && _this.orderType == 0) {
            _this.selectDateName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectTimeName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_name;
            _this.selectTime = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time;
            _this.selectTimeRange = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_range;
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          } else {
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDateName = '未选择（必选）';
            _this.selectDate = '';
            _this.selectTimeName = '';
            _this.selectTime = '';
            _this.selectTimeRange = '';
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          }
        }
        _this.giftUrl = _this.orderPreviewInfo.gift_url;
        if (_this.orderPreviewInfo.canSubmit) {
          let ment = window.localStorage.getItem('shop_comment');
          if (ment && ment != '') {
            _this.comment = ment;
          }
        }
        if(_this.orderPreviewInfo.isCanChooseDeliveryWay && _this.orderPreviewInfo.deliveryWayList.length > 0){
          for(let k of _this.orderPreviewInfo.deliveryWayList){
            if(k.selected){
              _this.deliveryWay = k.title
              _this.upstairsDelivery = k.upstairsDelivery
            }
          }
        }
        _this.isCanSubmit = true
        window.localStorage.setItem('orderPreviewInfo', JSON.stringify(_this.orderPreviewInfo))
        if (data.flag === 2001) {
          let goodsInfo = '', hikesInfo = '';
          if (data.update_goods && data.update_goods.length > 0) {//商品信息有误
            goodsInfo = data.update_goods[0].good_name + data.update_goods[0].message
          }
          if (data.update_hikes && data.update_hikes.length > 0) {//加价购商品信息有误
            hikesInfo = data.update_hikes[0].good_name + data.update_hikes[0].message
          }
          if (data.update_goods && data.update_goods.length > 0 && data.update_hikes && data.update_hikes.length > 0) {
            _this.$messagebox({
              title: '',
              message: goodsInfo + hikesInfo + '</br>已为您重新计算价格',
              showCancelButton: false
            });
          } else if (data.update_goods && data.update_goods.length > 0) {
            _this.$messagebox({
              title: '',
              message: goodsInfo + '</br>已为您重新计算价格',
              showCancelButton: false
            })
          } else if (data.update_hikes && data.update_hikes.length > 0) {
            _this.$messagebox({
              title: '',
              message: hikesInfo + '</br>已为您重新计算价格',
              showCancelButton: false
            });
          }
          return;
        }
        if (data.flag === 3005){
          _this.$messagebox({
            title: '',
            message: data.message,
            showCancelButton: false
          })
          return;
        }
        if (data.flag === 8001 && data.deliveryMode){
          _this.$messagebox({
            title: '',
            message: data.message,
            showCancelButton: true,
            confirmButtonText: '查看详情',
            cancelButtonText: '取消'
          }).then(res=>{
            // console.log(res);
            if(res == 'confirm'){
              _this.$router.push({path: '/findbuild'})
            }
          })
          return;
        }
        if (data.flag === 8001){
          _this.$messagebox({
            title: '',
            message: data.message,
            showCancelButton: false
          })
          return;
        }
        if (_this.orderPreviewInfo.needBuild && _this.orderPreviewInfo.needBuild == 1) {
          _this.getBuildInfo();
        }
      }, function (data) {
        _this.$messagebox.alert(data.data.message, '')
      })
    },
    //修改备注
    changeComment(){
      if(this.remarks.length>0){
        window.localStorage.setItem('remarks', this.remarks)
      }
    },
    // 提交订单
    createOrder: function () {
      var _this = this;
      if (_this.orderPreviewInfo.canSubmit) {
        if (_this.orderType == 0) {
          if (JSON.stringify(_this.defaultAddress) == '{}') {
            _this.$messagebox.alert('收货地址不能为空', '');
            return false;
          }
          if(_this.orderPreviewInfo.isCanChooseDeliveryWay && !_this.upstairsDelivery){
            _this.$messagebox.alert('配送方式不能为空', '');
            return false;
          }
          if (_this.selectTime == '-1') {
            _this.$messagebox.alert('今天已不能配送啦', '')
            return false;
          }
        } else if (_this.orderType == 1) {
          if (_this.selfTakeMp == null || _this.selfTakeMp == '' || _this.selfTakeMp == undefined) {
            _this.$messagebox.alert('手机号不能为空', '')
            return false;

          }
          var phonereg = /^1\d{10}$/;
          var phonereg2 = /^1\d{2}[*]{6}\d{2}/;
          // if (!phonereg.test(_this.selfTakeMp)) {
          if (!phonereg.test(_this.selfTakeMp) && !phonereg2.test(_this.selfTakeMp)) {
            _this.$messagebox.alert('请输入正确的手机号', '')
            return false;
          }

          if (!_this.isSelect) {
            _this.$messagebox.alert('同意服务协议才能下单', '')
            return false;
          }
          if (_this.orderPreviewInfo.needBuild) {
            for (let v of _this.buildInfo) {
              if (!v.name || v.name == '请选择') {
                _this.$messagebox.alert('请选择楼栋信息', '')
                return false;
              }
            }
          }
        } else {
          if (_this.selfTakeMp == null || _this.selfTakeMp == '' || _this.selfTakeMp == undefined) {
            _this.$messagebox.alert('手机号不能为空', '')
            return false;

          }
          var phonereg = /^1\d{10}$/;
          if (!phonereg.test(_this.selfTakeMp)) {
            _this.$messagebox.alert('请输入正确的手机号', '')
            return false;
          }
        }
        var params;
        // 配送方式为送货上门
        var rightGoods = [];
        if (_this.orderPreviewInfo.right_goods) {
          rightGoods = _this.orderPreviewInfo.right_goods;
        }
        var goods = [], gifts = [];
        if (rightGoods.length > 0) {
          for (var i = 0; i < rightGoods.length; i++) {
            var good = {};
            good.goods_sale_id = rightGoods[i].goods_sale_id + '';
            good.price = rightGoods[i].price;
            if (rightGoods[i].ori_price) {
              good.ori_price = rightGoods[i].ori_price
            }
            good.number = rightGoods[i].number;
            if (rightGoods[i].specification) {
              good.specification = rightGoods[i].specification
            }
            if (rightGoods[i].attributes) {
              good.attributes = rightGoods[i].attributes
            }
            if (rightGoods[i].attributePrice || rightGoods[i].attributePrice === 0) {
              good.attributePrice = rightGoods[i].attributePrice
            }
            goods.push(good)
          }
        }
        if (JSON.stringify(_this.defaultGift) != "{}") {
          var good = {};
          good.goods_sale_id = _this.defaultGift.goods_sale_id + '';
          good.price = _this.defaultGift.price;
          if (_this.defaultGift.ori_price) {
            good.ori_price = _this.defaultGift.ori_price
          }
          good.number = _this.defaultGift.number;
          gifts.push(good)
        }
        var gender;

        if (_this.selectDate == '' || _this.selectTime == '') {
          if (_this.orderType == 0) {
            _this.$messagebox.alert('请选择送达时间', '');
          } else if (_this.orderType == 1) {
            _this.$messagebox.alert('请选择自提时间', '');
          } else {
            _this.$messagebox.alert('请选择就餐时间', '');
          }
        } else {
          if (_this.defaultAddress.gender === '男') {
            gender = 1
          } else {
            gender = 0
          }

          //订单备注
          if(_this.orderPreviewInfo.isOrderRemark && !_this.remarks){
            _this.$messagebox.alert('根据学校运营需要，本店铺订单备注必填', '');
          }

          if (_this.orderType == 0) {
            params = {
              packPrice: _this.orderPreviewInfo.packing_fee,
              consignee: _this.defaultAddress.addressee_encryption,
              consignee_tel_encryption: _this.defaultAddress.mp_encryption,
              // consignee_tel: _this.defaultAddress.mp_encryption + '',
              gender: gender,
              supplier_id: _this.orderPreviewInfo.supplier_id + '',
              address_id: _this.defaultAddress.id + '',
              address_summary: _this.defaultAddress.poi_address,
              address_detail: _this.defaultAddress.detail,
              address_lat: _this.defaultAddress.lat,
              address_lng: _this.defaultAddress.lon,
              goods: goods,
              // hikes: _this.orderPreviewInfo.right_hikes,
              gifts: gifts,
              // client_type: 7,
              delivery_date: _this.selectDate,
              delivery_time: _this.selectTime,
              delivery_time_range: _this.selectTimeRange,
              comment: _this.remarks,
              orderType: _this.orderType,
            }
          } else {
            params = {
              packPrice: _this.orderPreviewInfo.packing_fee,
              // consignee_tel: _this.selfTakeMp + '',
              consignee_tel_encryption: _this.$utils.Encrypt(_this.selfTakeMp + ''),
              gender: gender,
              supplier_id: _this.orderPreviewInfo.supplier_id + '',
              goods: goods,
              // hikes: _this.orderPreviewInfo.right_hikes,
              gifts: gifts,
              // client_type: 7,
              delivery_date: _this.selectDate,
              delivery_time: _this.selectTime,
              delivery_time_range: _this.selectTimeRange,
              comment: _this.remarks,
              orderType: _this.orderType,
              pickUpAddr: _this.orderPreviewInfo.pickUpAddr,
            }
            if (_this.defaultAddress.addressee) {
              // params.consignee = _this.defaultAddress.addressee_encryption;
              params.consignee = _this.$utils.Decrypt(_this.defaultAddress.addressee_encryption);

            } else {
              params.consignee = _this.$store.state.userInfo.nickname
            }
            // console.log(_this.buildInfo)
            if (_this.orderPreviewInfo.needBuild && _this.orderPreviewInfo.needBuild == 1 && _this.orderType == 0) {
              params.building = _this.buildInfo[0].name;
              params.buildingId = _this.buildInfo[0].id;
              params.floor = _this.buildInfo[1].name;
              params.floorId = _this.buildInfo[1].id;
              params.room = _this.buildInfo[2].name;
              params.roomId = _this.buildInfo[2].id;
            }
          }
          if(_this.orderPreviewInfo.isCanChooseDeliveryWay && _this.orderType == 0){ //楼层
            params.buildingId = _this.defaultAddress.build_id;
            params.building = _this.defaultAddress.build_name;
            params.floorId = _this.defaultAddress.floor_id;
            params.floor = _this.defaultAddress.floor_name;
            params.roomId = _this.defaultAddress.room_id;
            params.room = _this.defaultAddress.room_name;
            params.upstairsDelivery = _this.upstairsDelivery
          }
          if (_this.orderPreviewInfo.reductionAmount) {
            params.reductionAmount = _this.orderPreviewInfo.reductionAmount
          }
          let hikes = [];//加价购
          if (_this.orderPreviewInfo.right_hikes) {
            for (let item of _this.orderPreviewInfo.right_hikes) {
              if (item.number > 0) {
                hikes.push(item)
              }
            }
          }
          params.hikes = hikes;
          if (_this.couponInfo != null) {
            params.couponAmount = _this.orderPreviewInfo.couponAmount
            params.userCouponId = _this.couponInfo.user_coupon_id
            params.couponId = _this.couponInfo.coupon_id
          } else {
            delete params.couponAmount
            delete params.userCouponId
            delete params.coupon_id
          }
          if (_this.orderPreviewInfo.deliveryFeeCouponId) {
            params.isUseDeliveryFeeCoupon = true;
            params.deliveryFeeCouponAmount = _this.orderPreviewInfo.deliveryFeeCouponAmount;
            params.deliveryFeeUserCouponId = _this.orderPreviewInfo.deliveryFeeUserCouponId;
            params.deliveryFeeCouponId = _this.orderPreviewInfo.deliveryFeeCouponId;
          } else {
            params.isUseDeliveryFeeCoupon = false;
            delete params.deliveryFeeCouponAmount;
            delete params.deliveryFeeUserCouponId;
            delete params.deliveryFeeCouponId;
          }

          if (_this.orderPreviewInfo.activityJoinPreCheck) {
            params.activityJoinOrder = _this.orderPreviewInfo.activityJoinPreCheck;
          }
          params.source = _this.source;

          // 下单用户类型
          if (_this.$utils.getCookie('userType') == 1 || _this.$utils.getCookie('userType') == 2) {
            params.userType = _this.$utils.getCookie('userType');
          } else {
            params.userType = 0;
          }
          // 梨涡特殊处理
          if (_this.source == 'jdlw') {
            params.h5_device_id = this.jdlwTokenStr
          }
          // saas
          if(_this.orderPreviewInfo.reqReserved){
            params.reqReserved = _this.orderPreviewInfo.reqReserved;
          }
          if(_this.orderPreviewInfo.punctualArrive && _this.orderPreviewInfo.punctualArrive.aimed){
            params.buyInsurance = _this.orderPreviewInfo.punctualArrive.aimed;
          }
          window.localStorage.removeItem("remarks")
          _this.isCanSubmit = false;
          _this.$indicator.open();//loading
          actions.postOrderCreate(_this, params, function (newdata) {
            _this.$indicator.close()
            if (newdata.status === 0) {
              let code = window.localStorage.getItem('shop_code');
              let shopInfo = _this.$store.state.shopCodeInfo;
              shopInfo[newdata.orderId] = code;
              _this.createOrderId = newdata.orderId;
              window.localStorage.setItem('orderCode', _this.createOrderId);
              let shopcode = shopInfo[_this.createOrderId];
              delete shopInfo[_this.createOrderId];
              _this.$store.commit('changeShopCodeInfo', shopInfo);
              delete _this.cartInfo[shopcode];
              _this.$store.commit('changeCartInfo', _this.cartInfo);
              window.localStorage.setItem('canSubmit', 1)
              window.localStorage.setItem('orderPreviewInfo', JSON.stringify(_this.orderPreviewInfo));

              _this.orderPreviewInfo.canSubmit = false;
              window.localStorage.setItem('order-type', _this.orderType)
              window.localStorage.setItem('orderCode', _this.createOrderId);

              // 常州纺织学院支付收银台
              let cfSchoolId;
              if (process.env.NODE_ENV == 'production') {
                cfSchoolId = 2803;
              } else {
                cfSchoolId = 1816;
              }
              if (cfSchoolId == _this.$store.state.schoolInfo.schoolId) {
                _this.getSchoolCardInfo();
              } else {
                // 下单成功
                _this.clickLog('food_order_info')
                _this.$router.push({name: 'Payment'});
                window.localStorage.removeItem('selectedCoupon')
                window.localStorage.removeItem('selectedDeliveryCoupon')
              }
            } else if (newdata.status === 2000) { //赠品校验不通过
              _this.$messagebox({
                title: '',
                confirmButtonText: '不用了，谢谢',
                cancelButtonText: '返回重选',
                message: '当前赠品已无库存，是否返回重选？',
                showCancelButton: true
              }).then(function () {
                window.localStorage.setItem('order-type', _this.orderType)
                window.localStorage.setItem('orderCode', _this.createOrderId);
                _this.clickLog('food_order_info')
                _this.$router.push({name: 'Payment'})
//                  if (_this.$utils.isWeiXin()) { //判断是否微信浏览器中打开
//                    _this.wxBridgeready()
//                  } else {
//                    window.localStorage.setItem('order-type', _this.orderType)
//                    window.localStorage.setItem('orderCode', _this.createOrderId);
//                    _this.$router.push({name: 'Payment'})
//                  }
              })
            } else if (newdata.status === 1010 || newdata.status === 3000) {
              _this.$messagebox.alert(newdata.message, '')
              _this.isCanSubmit = true;
            } else {
              // _this.$messagebox.alert(newdata.wrongGoodsList[0].msg, '')
              _this.isCanSubmit = true;
              _this.secondCalculate();
            }
          }, function (newdata) {
            _this.$indicator.close()
            _this.$messagebox.alert(newdata.data.message, '')
            _this.isCanSubmit = true;
            _this.secondCalculate();
          })
        }
      }
    },
    //新埋点
    clickLog(code){
      var _this = this;
      var params = {
        logDetails: [{
          uid: _this.$store.state.wxUid,
          refId: _this.createOrderId,
          firstValue: _this.schoolInfo.schoolId,
          createTime: new Date().getTime(),
          code: code,
        }]
      }
      actions.postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {

      })
    },
    getSchoolCardInfo() {
      let _this = this;
      // _this.orderSubmitType = 2;
      actions.schoolCardInfo(_this, {school_id: _this.$store.state.schoolInfo.schoolId}, function (data) {
        if (data && data.card_no) {
          _this.schoolCardCode = data.card_no;
        } else {
          _this.schoolCardCode = '';
        }

        _this.cfPay();
      }, function () {
        _this.cfPay();
      })
    },
    // 常州纺织学院支付收银台
    cfPay: function () {
      let _this = this;
      this.$messagebox({
        title: '',
        $type: 'prompt',
        message: '请输入学生卡号',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '请输入正确的学工号',
        inputValue: _this.schoolCardCode,
        showCancelButton: true,
        showInput: true
      }).then(({value, action}) => {
        this.schoolCardCode = value;
        let params = {
          cfOrderInfo: encodeURIComponent(JSON.stringify({accNum: value})),
          order_id: _this.createOrderId,
          payType: 92
        }
        actions.postWxJsPay(_this, params, function (data) {
          const div = document.createElement('div');
          div.innerHTML = data;
          document.body.appendChild(div);
          document.forms[0].submit();
        })
      })
    },
    wxBridgeready: function () {
      //开始调起微信支付
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.wxpay, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.wxpay);
          document.attachEvent('onWeixinJSBridgeReady', this.wxpay);
        }
      } else {
        this.wxpay();
      }
    },
    //微信支付
    wxpay: function () {
      var _this = this;
      var u = window.location.href.split('#')[0];
      actions.getJslbsConf(this, u, function (data) {
        var wxappid = JSON.parse(data).appId
        var params = {
          order_id: _this.createOrderId,
          payType: 9, //h5支付为12
          openid: _this.$store.state.openId,
          //type:1 //临时变量 暂时未cbd公众号支付
        };
        actions.postWxJsPay(_this, params, function (redata) {
          _this.$indicator.close();
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId": wxappid,        //公众号名称，由商户传入
              "timeStamp": redata.timeStamp,     //时间戳，自1970年以来的秒数
              "nonceStr": redata.rndStr,     //随机串
              "package": redata.xpackage,
              "signType": "MD5",     //微信签名方式：
              "paySign": redata.sign       //微信签名
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                actions.getredPacketShare(_this, {order_id: _this.createOrderId}, function (data) {
                  if (data) {
                    window.localStorage.setItem('redPacket', JSON.stringify(data))
                  }
                }, function () {
                })
              } else {
                // _this.$messagebox.alert('支付失败！', '');
                alert('支付失败:' + JSON.stringify(res));
              }
              window.localStorage.setItem('order-type', _this.orderType)
              _this.$router.push({name: 'OrderDetail'})
            }
          )
        }, function (data) {
          _this.$indicator.close();
          _this.$messagebox.alert(data.data.message, '');
        })
      })
    },

    // 自提选择楼栋信息
    toChoseBuilding: function () {
      this.showBuildingPop = true;
      for (let v of this.buildInfo) {
        v.checked = false;
      }
      this.buildInfo[0].checked = true;
      this.getShopBuildingList();
    },
    getShopBuildingList() {
      let _this = this;
      let params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code')
      }
      actions.postShopBuildList(_this, params, data => {
        if (data && data.length > 0) {
          for (let v of data) {
            v.checked = false;
            if (this.buildInfo[0].id) {
              if (v.id == this.buildInfo[0].id) {
                v.checked = true;
              }
            }
            // if(type == 2){
            //   if(this.buildInfo[1].id){
            //     if(v.id == this.buildInfo[1].id){
            //       v.checked = true;
            //     }
            //   }
            // }else if(type == 3){
            //   if(this.buildInfo[2].id){
            //     if(v.id == this.buildInfo[2].id){
            //       v.checked = true;
            //     }
            //   }
            // }else{
            //   if(this.buildInfo[0].id){
            //     if(v.id == this.buildInfo[0].id){
            //       v.checked = true;
            //     }
            //   }
            // }
          }
          this.buildingList = data;
        } else {
          this.buildingList = [];
        }
      })
    },
    getBuildingList(type, code) {
      let _this = this;
      let params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code'),
        type: type || '',
        code: code || ''
      }
      actions.postBuildList1(_this, params, data => {
        if (data && data.length > 0) {
          for (let v of data) {
            v.checked = false;
            if (type == 2) {
              if (this.buildInfo[1].id) {
                if (v.id == this.buildInfo[1].id) {
                  v.checked = true;
                }
              }
            } else if (type == 3) {
              if (this.buildInfo[2].id) {
                if (v.id == this.buildInfo[2].id) {
                  v.checked = true;
                }
              }
            } else {
              if (this.buildInfo[0].id) {
                if (v.id == this.buildInfo[0].id) {
                  v.checked = true;
                }
              }
            }
          }
          this.buildingList = data;
        } else {
          this.buildingList = [];
        }
      })
    },
    changeBuildingTitle(item, index) {
      for (let v of this.buildInfo) {
        v.checked = false;
      }
      item.checked = true;
      if (index == 0) {
        this.getShopBuildingList();
      } else if (index == 1) {
        this.getBuildingList(2, this.buildInfo[0].id);
      } else if (index == 2) {
        this.getBuildingList(3, this.buildInfo[1].id);
      }
    },
    changeBuilding(item) {
      for (let v of this.buildInfo) {
        v.checked = false;
      }
      for (let v of this.buildingList) {
        v.checked = false;
        if (item.id == v.id) {
          v.checked = true;
        }
      }
      // item.checked = true;
      // console.log(this.buildingList)
      if (item.type == 1) {
        this.buildInfo[0].id = item.id;
        this.buildInfo[0].name = item.area;
        this.buildInfo[1].checked = true;
        this.buildInfo[1].name = '请选择';
        this.buildInfo[2].name = '请选择';
        this.showChoseBuilding = true;
        this.getBuildingList(2, item.id);
      } else if (item.type == 2) {
        this.buildInfo[1].id = item.id;
        this.buildInfo[1].name = item.area;
        this.buildInfo[2].checked = true;
        this.buildInfo[2].name = '请选择';
        this.showChoseBuilding = true;
        this.getBuildingList(3, item.id);
      } else {
        this.buildInfo[2].id = item.id;
        this.buildInfo[2].name = item.area;
        this.showBuildingPop = false;
        this.showChoseBuilding = false;
        // 保存楼栋信息
        this.saveBuildInfo();
      }
    },
    saveBuildInfo() {
      let _this = this;
      let params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        // shop_id: localStorage.getItem('shop_code'),
        type: 1,
        build_id: this.buildInfo[0].id,
        build_name: this.buildInfo[0].name,
        floor_id: this.buildInfo[1].id,
        floor_name: this.buildInfo[1].name,
        room_id: this.buildInfo[2].id,
        room_name: this.buildInfo[2].name,
        lon: '',
        detail: '',
        poi_address: '',
        mp: '',
        lat: '',
        gender: '',
        addressee: '',
        is_build: 1,
        addressType: 1
      }
      if (this.pickUpAddress && this.pickUpAddress.id) {
        params.id = this.pickUpAddress.id;
      }
      actions.savePickupAddress(_this, params, data => {

      })
    },
    getBuildInfo() {
      let _this = this;
      let params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code')
      }
      actions.pickupInfo(_this, params, data => {
        if (data) {
          this.pickUpAddress = data;
          this.buildInfo[0].id = data.build_id;
          this.buildInfo[0].name = data.build_name;
          this.buildInfo[1].id = data.floor_id;
          this.buildInfo[1].name = data.floor_name;
          this.buildInfo[2].id = data.room_id;
          this.buildInfo[2].name = data.room_name;
          this.showChoseBuilding = false;
          // console.log(this.buildInfo)
        }
      }, data => {
        _this.$messagebox.alert(data.data.message, '');
        _this.buildInfo = [{id: ' ', name: '请选择', checked: true}, {id: ' ', checked: false}, {
          id: ' ',
          checked: false
        }];
      })
    },
    viewPackDesc() {
      this.$router.push({name: 'PackingFee'});
    },
    // 显示收费名目
    showOrderFeeDesc(item) {
      if(item.isShowDesc){
        item.showDesc = !item.showDesc;
      }
    },
    // 获取券包
    getCouponPackageList() {
      let _this = this;
      let params = {
        school_id: _this.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code'),
        source: 1
      };
      actions.postPackageList(_this, params, (data) => {
        if (data && data.length > 0) {
          _this.couponPackageList = data;
          var clickParams = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_order_coupon_bag',
            createTime: new Date().getTime(),
            refId: _this.couponPackageList[0].package_id,
            firstValue: _this.schoolInfo.schoolId,
            secondValue: _this.shopCode
          }]
          _this.addLog1(clickParams);
        }
      });
    },
    // 购买券包
    buyCouponPackage(item) {
      this.$router.push({name: 'CouponPackage', query: {id: item.package_id}})
      var clickParams = [{
        uid: this.$store.state.wxUid,
        code: 'click_order_coupon_bag',
        createTime: new Date().getTime(),
        refId: item.package_id,
        firstValue: this.schoolInfo.schoolId,
        secondValue: this.shopCode
      }]
      this.addLog1(clickParams);
    },
    // 统计埋点
    addLog1(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      }
      actions.postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {

      })
    },
    // 准时达
    viewPunctualArrive() {
      if(this.orderPreviewInfo.punctualArrive.jumpParam){
        this.$router.push({name: 'PunctualArrive'});
      }
    },
    getUserAgreement() {
      return new Promise((resolve, reject) => {
        let _this = this;
        actions.getUserInfoFullByUid(_this, {}, (res)=> {
          if (res.user_version_agreement && res.version_agreement) {
            resolve(res);
            this.versionAgreement = {user_version_agreement: res.user_version_agreement, version_agreement: res.version_agreement};
          }
        })
      })
    },
    changePunctualArrive() {
      let aimed = this.orderPreviewInfo.punctualArrive.aimed;
      let versionAgreement = this.versionAgreement;
      if(!versionAgreement.user_version_agreement){
        this.getUserAgreement().then((res)=>{
          this.changePunctualArrive();
        })
        return;
      }
      if(versionAgreement.user_version_agreement.zsd && versionAgreement.version_agreement.zsd){
        if((versionAgreement.user_version_agreement.zsd.version_number || 0) < versionAgreement.version_agreement.zsd.version_number){
          this.$messagebox({
            title: '准时达协议',
            message: versionAgreement.version_agreement.zsd.agreement_content,
            showCancelButton: true,
            confirmButtonText: '同意',
            cancelButtonText: '取消'
          }).then(res=>{
            if(res == 'confirm'){
              this.submitUserAgree();
            }
          })
          return;
        }
      }
      aimed = 1 - aimed;
      this.buyInsurance = aimed;
      this.secondCalculate();
    },
    submitUserAgree() {
      var _this = this;
      actions.setUserSignContract(_this, {type: 1}, (data) => {
        this.getUserAgreement().then((res)=>{
          this.changePunctualArrive();
        })
      })
    }
  }
}
</script>
<style scoped>
 .fc-999{
   color: #999;
 }
 .opa-5{
   opacity: 0.5;
 }
 .card{
  padding: 0.3rem 0.2rem;
  background-color: #fff;
  margin-bottom: .2rem;
 }
</style>



// WEBPACK FOOTER //
// OrderSettle.vue?438cf8f4